import { type ReactElement } from 'react';

import { AccountGate } from './account/AccountGate';
import { GameCanvas } from './game/game-canvas';
import { parseLaunch } from './game/launch';

/**
 * The application shell, and the one fork above the account boundary.
 *
 * Almost everything goes through `AccountGate`: a visitor signs in, picks a
 * character, and only then is a canvas built. The exception is the **renderer
 * sandbox** (`?solo`), which connects to nothing at all — no room, nobody else,
 * nothing authoritative (`game/launch.ts`) — and therefore has nobody to be.
 * Putting a sign-in wall in front of it would be asking for a password to look
 * at a cave, and would make the browser suite's renderer specs sign in to
 * exercise code that never opens a socket.
 *
 * Read once, at the top, because it is a property of the URL this page was
 * loaded with and cannot change without a navigation.
 */
const solo = parseLaunch(window.location.search).solo;

export const App = (): ReactElement => (
  <main className="shell">
    <h1 className="shell__title">d2</h1>
    {solo ? (
      // No account, so no character, so no class and no skill tree. The HUD
      // stays away too: nothing is authoritative here, so there is no life,
      // mana or experience to draw (`game/launch.ts`).
      <GameCanvas token={null} characterId={null} characterClass={null} onSessionEnded={(): void => undefined} />
    ) : (
      <AccountGate />
    )}
  </main>
);
